var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 89.93 105.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bd9913a4-207c-498f-a84b-e21c39c239a8{stroke-miterlimit:10;stroke-width:3.44px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f16aae04-689e-450d-99df-55e581b1dce6",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a9f2b9c2-adac-4b36-b155-dfffaad6d401",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "bd9913a4-207c-498f-a84b-e21c39c239a8",
    cx: 44.94,
    cy: 23.7,
    r: 21.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd9913a4-207c-498f-a84b-e21c39c239a8",
    d: "M1.72,99.25V89.92A33.45,33.45,0,0,1,35.17,56.47H54.76A33.44,33.44,0,0,1,88.21,89.92v9.33a4.13,4.13,0,0,1-4.13,4.13H5.85A4.13,4.13,0,0,1,1.72,99.25Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.36d3c2a5d073c6e4c874d1850fbbaf46.svg";
export { ForwardRef as ReactComponent };